<template>
  <!-- استفاده از استایل شیشه ای برای کارت اصلی -->
  <v-card class="glass-card rounded-xl mb-4 w-100" elevation="0" @click="sheet = true">
    <div class="d-flex p-3 w-100 align-stretch">
      
      <div class="position-relative pa-2 d-flex flex-column align-center justify-center">
        <!-- بج تخفیف (بالا سمت راست عکس) -->
        <div
          v-if="!!value.discount_amount"
          class="discount-badge elevation-2"
        >
        <span v-if="value.discount_type !== 'price'">٪</span>
      {{ use_lang(price(value.discount_amount)) }}
      <span v-if="value.discount_type === 'price'" style="font-size: x-small">{{
        currencySymbol || 'ریال'
      }}</span>
        </div>

        <!-- عکس دایره ای -->
        <v-avatar size="110" class="glass-avatar elevation-2">
          <v-img v-if="!!thumbnail" :src="thumbnail" style="object-fit: cover;"></v-img>
          <v-img v-else-if="!!defaultImage" :src="defaultImage" style="opacity: 0.6; object-fit: cover;"></v-img>
          <v-icon v-else size="40" color="grey lighten-1">mdi-image-outline</v-icon>
        </v-avatar>

        <!-- بج قیمت (پایین عکس) -->
        <div class="price-badge transition-swing">
          <span class="font-weight-black text-body-2"> {{ use_lang(price(value.price)) }}</span>
          <span class="text-caption mr-1" style="opacity: 0.9;">{{ currencySymbol || 'ریال' }}</span>
        </div>
      </div>

      <!-- ========================================== -->
      <!-- بخش چپ: عنوان، توضیحات و اکشن‌های سبد خرید -->
      <!-- ========================================== -->
      <div class="flex-grow-1 pl-3 pr-2 py-3 d-flex flex-column justify-space-between" style="min-width: 0;">
        
        <div>
          <!-- هدر: نام محصول و دکمه جزئیات نقشه/ویژگی‌ها -->
          <div class="d-flex justify-space-between align-start mb-1">
            <h3 class="text-subtitle-2 font-weight-black text-truncate primary--text text--darken-2 pr-1" style="line-height: 1.4;">
              {{ value.name }}
            </h3>
            
            <v-dialog v-if="hasDetails" v-model="openMap" max-width="400">
              <template v-slot:activator="{ on, attr }">
                <v-btn icon small v-bind="attr" v-on="on" class="mt-n1 ml-n2" @click.stop>
                  <v-icon color="grey darken-1">mdi-information-outline</v-icon>
                </v-btn>
              </template>
              <v-card class="rounded-xl">
                <v-toolbar color="primary" dark elevation="0">
                  <v-toolbar-title class="text-subtitle-1">{{ $t("procart.features") }}</v-toolbar-title>
                  <v-spacer />
                  <v-btn icon @click="openMap = false"><v-icon>mdi-close</v-icon></v-btn>
                </v-toolbar>
                <extra-shown v-model="computedExtra" class="pa-4" />
              </v-card>
            </v-dialog>
          </div>

          <!-- توضیحات محصول (حداکثر ۲ خط) -->
          <div 
            v-if="value.description"
            class="text-caption grey--text text--darken-2 text-truncate-2 pr-1"
            v-html="value.description"
          ></div>
          
          <!-- قیمت خط خورده در صورت داشتن تخفیف -->
          <div v-if="!!computedOption.discount_amount" class="text-caption grey--text text-decoration-line-through mt-1 pr-1">
             {{ use_lang(price(computedOption.price)) }} {{ currencySymbol || 'ریال' }}
          </div>
        </div>

        <!-- کنترل‌های افزودن به سبد خرید (پایین سمت چپ) -->
        <div class="d-flex justify-end align-center mt-2" @click.stop>
          <!-- <cart-actions
            v-model="computedValue"
            :max-order="computedOption.max_order"
            :optionId="hasOptions ? computedOption.id : null"
            :pending="sheet"
            :specialId="value.special?.[0]?.id || null"
            :cart-button-text="cartButtonText"
          /> -->
        </div>
      </div>
    </div>

    <!-- ========================================== -->
    <!-- مُدال جزئیات محصول (Bottom Sheet) -->
    <!-- ========================================== -->
    <v-bottom-sheet v-model="sheet" max-width="600" scrollable>
      <v-card :loading="loading" class="glass-sheet rounded-t-xl" max-height="85vh" style="display: flex; flex-direction: column;">
        
        <div class="px-4 py-3 d-flex justify-space-between align-center flex-nowrap sheet-header">
          <div class="text-subtitle-1 font-weight-black text-truncate" style="max-width: calc(100% - 40px);">
            {{ value.name }}
          </div>
          <v-btn icon small class="grey lighten-3 flex-shrink-0" @click="sheet = false">
            <v-icon small color="grey darken-3">mdi-close</v-icon>
          </v-btn>
        </div>

        <v-card-text class="pa-4 flex-grow-1 overflow-y-auto" style="padding-bottom: 90px !important;">
          <v-row no-gutters>
            <!-- عکس بزرگ مُدال -->
            <v-col cols="12" class="d-flex justify-center mb-6 position-relative">
              <v-avatar class="rounded-circle elevation-3 glass-avatar" size="160">
                <v-img v-if="!!thumbnail" :src="thumbnail" style="object-fit: cover;" />
                <v-img v-else-if="!!defaultImage" :src="defaultImage" style="opacity: 0.6; object-fit: cover;" />
                <v-icon v-else size="60" color="grey lighten-1">mdi-image-outline</v-icon>
              </v-avatar>

              <v-chip
                v-if="!!computedOption.discount_amount"
                color="error"
                text-color="white"
                size="small"
                class="font-weight-bold px-3 elevation-2"
                style="position: absolute; top: 10px; right: 15%; z-index: 2;"
              >
                {{ use_lang(price(computedOption.discount_amount)) }}
                <span v-if="computedOption.discount_type !== 'price'" class="mr-1">٪</span>
              </v-chip>
            </v-col>

            <v-col cols="12">
              <div 
                v-if="value.description"
                class="grey--text text--darken-3 text-justify mb-5 text-body-2 glass-box pa-3 rounded-lg" 
                style="line-height: 1.8;"
                v-html="value.description"
              ></div>

              <!-- انتخاب رنگ -->
              <div v-if="!!colors.length && selectedColor != null" class="mb-5 glass-box pa-3 rounded-lg">
                <div class="text-caption font-weight-bold mb-3 d-flex align-center">
                  <v-icon small color="primary" class="ml-1">mdi-palette-outline</v-icon>
                  {{ $t("procart.color") }}: <span class="mr-2 primary--text">{{ colors[selectedColor].name }}</span>
                </div>
                <div class="d-flex flex-wrap gap-2">
                  <div
                    v-for="(option, i) in colors"
                    :key="i"
                    :class="{ 'elevation-3': selectedColor === i }"
                    class="rounded-circle pa-1 clickable transition-swing"
                    :style="selectedColor === i ? `border: 2px solid ${option.value};` : 'border: 2px solid transparent;'"
                    @click="selectedColor = i"
                  >
                    <v-avatar :color="option.value" size="32" class="elevation-1"></v-avatar>
                  </div>
                </div>
              </div>

              <!-- ویژگی‌ها -->
              <div v-if="!!value.details && value.details.length > 0" class="mb-2 glass-box pa-3 rounded-lg">
                <div class="text-caption font-weight-bold mb-3 d-flex align-center">
                  <v-icon small color="primary" class="ml-1">mdi-format-list-bulleted</v-icon>
                  {{ $t("procart.features") }}
                </div>
                <div>
                  <template v-for="(extra, j) in value.details">
                    <div
                      v-if="!!extra.icon || !!extra.value"
                      :key="j"
                      class="d-flex align-center py-2 text-body-2 border-bottom-light"
                    >
                      <v-icon v-if="extra.icon" color="primary" small class="ml-2">
                        {{ extra.icon }}
                      </v-icon>
                      <span v-else class="grey--text text--darken-1 ml-1">{{ extra.label }}:</span>
                      <span class="font-weight-medium black--text">{{ extra.value }}</span>
                    </div>
                  </template>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-card-text>

        <!-- فوتر چسبان مُدال -->
        <v-card-actions class="sheet-footer pa-4 d-flex flex-column">
          <div class="d-flex justify-space-between align-center w-100 mb-2">
            <div class="d-flex flex-column align-start">
              <div v-if="!!computedOption.discount_amount" class="text-decoration-line-through grey--text text-caption">
                {{ use_lang(price(computedOption.price)) }}
              </div>
              <div class="primary--text font-weight-black text-h5 d-flex align-center">
                {{ use_lang(price(priceWithDiscount)) }}
                <span class="grey--text text-caption mr-1">{{ currencySymbol || 'ریال' }}</span>
              </div>
            </div>
            <div>
              <!-- <cart-actions
                v-model="computedValue"
                :max-order="computedOption.max_order"
                :optionId="hasOptions ? computedOption.id : null"
                :specialId="value.special && value.special.length ? value.special[0].id : null"
              /> -->
            </div>
          </div>
          <v-btn v-if="!$vuetify.breakpoint.xsOnly" color="primary" elevation="2" block rounded class="font-weight-bold mt-2" style="min-height: 48px;" @click="changeLocation('/cart')">
            {{ cartButtonText || 'مشاهده سفارش' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-bottom-sheet>
  </v-card>
</template>

<script>
import { mapState } from "vuex";
import ExtraShown from "@/view/components/Product/extraShown";
// import CartItem from "../../fragments/cart/CartItem.vue";
// import CartActions from "../../fragments/cart/CartActions.vue";

export default {
  name: "mProductCard",
  components: {  ExtraShown },
  
  props: {
    value: Object,
    currencySymbol: {
      type: String,
      default: 'ریال'
    },
    cartButtonText: {
      type: String,
      default: 'افزودن'
    },
    defaultImage: {
      type: String,
      default: "/img/default-placeholder.png", 
    }
  },
  
  data: () => ({
    openMap: false,
    sheet: false,
    loading: false,
    product: {},
    selectedColor: 0,
  }),
  
  mounted() {
    if (this.value?.options?.length && this.value.options instanceof Array) {
      let colors = this.value.options.filter((item) => item.type === "color");
      this.selectedColor = colors.length ? 0 : null;
    }
  },
  
  watch: {
    sheet(isOpen) {
      this.$root.$emit("sheet-state-change", isOpen);
    },
    "$i18n.locale": {
      handler() {
        this.$forceUpdate();
      },
      immediate: true,
      deep: true,
    },
  },
  
  computed: {
    ...mapState("cart", ["cart"]),

    computedCurrencyText() {
      return this.currency || this.$t("procart.unit_price");
    },

    computedValue: {
      get() {
        let currentOptionId = this.hasOptions ? this.computedOption.id : null;
        let itemInCart = this.cart.find(
          (c) => 
            c.id === this.value.id && 
            (c.optionId == currentOptionId || c.option_id == currentOptionId)
        );
        return {
          ...this.value,
          count: itemInCart ? itemInCart.count : 0
        };
      },
      set(val) {
        if (!this.validateCount(val.count)) return;
        this.$store.dispatch("cart/changeCount", {
          id: this.value.id,
          optionId: this.hasOptions ? this.computedOption.id : null,
          specialId: this.value.special?.[0]?.id || null,
          count: val.count,
        });
        this.$emit("input", val);
      },
    },
    hasDetails() {
      return (
        this.value.details?.filter(
          (item) => !!item.label || !!item.value || !!item.icon || !!item.link
        )?.length > 0
      );
    },
    priceWithDiscount() {
      const discount =
        Number(this.value.special?.[0]?.total_discount) ||
        Number(this.computedOption.discount_amount) ||
        0;
      if (discount) {
        if (this.computedOption.discount_type === "price") {
          return this.computedOption.price - discount;
        }
        return Math.floor((this.computedOption.price * (100 - discount)) / 100);
      }
      return this.computedOption.price;
    },
    colors() {
      return this.value.options instanceof Array
        ? this.value.options.filter((item) => item.type === "color")
        : [];
    },
    hasOptions() {
      return !!this.colors?.length && this.selectedColor != null;
    },
    computedOption() {
      let obj = this.hasOptions ? this.colors[this.selectedColor] : this.value;
      return {
        ...obj,
        price: obj.price || this.value.price, 
        discount_amount: Number(this.value.special?.[0]?.total_discount || obj.discount_amount || 0),
        discount_type: this.value.special?.[0]?.total_discount ? "percent" : obj.discount_type || "percent",
        max_order: obj.max_order || this.value.special?.[0]?.max_per_order || this.value.max_order || 100,
      };
    },

    thumbnail() {
      let gallery = !!this.value?.gallery
        ? typeof this.value?.gallery === "string"
          ? JSON.parse(this.value.gallery)[0]
          : this.value.gallery[0]
        : { name: "", images: [] };
      return gallery?.images?.length > 0 ? gallery.images[0].url : "";
    },
    hasExtra() {
      let e = !!this.value.extra && typeof this.value.extra === "string" ? JSON.parse(this.value.extra) : [];
      return e.filter((item) => !!item.label || !!item.value || !!item.icon || !!item.link)?.length > 0;
    },
    computedExtra() {
      return !!this.hasExtra ? JSON.parse(this.value.extra) : [];
    },
  },
  methods: {
    validateCount(count) {
      const maxPerCustomer = this.value.special?.[0]?.max_per_customer || Infinity;
      const totalInCart = this.$store.state.cart.cart
        .filter(
          (x) =>
            x.id === this.value.id &&
            x.optionId === (this.hasOptions ? this.computedOption.id : null) &&
            x.specialId === (this.value.special?.[0]?.id || null)
        )
        .reduce((sum, x) => sum + x.count, 0);
      if (totalInCart + count > maxPerCustomer) {
        this.$toast.error(this.$t("procart.max_per_customer_exceeded", { max: maxPerCustomer }));
        return false;
      }
      return true;
    },
    changeLocation(route) {
      let id = this.$store.state.local.qr_id;
      localStorage.setItem("qr", id);
      this.gotoApp("/cart");
    },
  },
};
</script>

<style scoped>
/* ========================================== */
/* استایل‌های شیشه‌ای (Glassmorphism) */
/* ========================================== */
.glass-card {
  background: rgba(255, 255, 255, 0.45) !important;
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border: 3px solid rgba(255, 255, 255, 1) !important;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4) !important;
  overflow: visible;
  transition: all 0.3s ease;
}

.glass-card:active {
  transform: scale(0.98);
}

.glass-avatar {
  background: rgba(255, 255, 255, 0.8) !important;
  border: 3px solid rgba(163, 142, 7, 0.76);
}

/* ========================================== */
/* بج قیمت روی عکس */
/* ========================================== */
.price-badge {
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  background: var(--v-primary-base, #0d8ddc); /* استفاده از رنگ اصلی سایت */
  color: white;
  padding: 4px 12px;
  border-radius: 20px;
  box-shadow: 0 4px 10px rgba(13, 141, 220, 0.3);
  white-space: nowrap;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(255, 255, 255, 0.3);
}

/* ========================================== */
/* بج تخفیف */
/* ========================================== */
.discount-badge {
  position: absolute;
  top: 0;
  right: 0;
  background: #ff5252;
  color: white;
  font-size: 11px;
  font-weight: bold;
  padding: 2px 8px;
  border-radius: 12px;
  z-index: 2;
  box-shadow: 0 2px 6px rgba(255, 82, 82, 0.4);
}

/* ========================================== */
/* برش متن توضیحات برای جلوگیری از به هم ریختگی */
/* ========================================== */
.text-truncate-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  line-height: 1.5;
}

/* ========================================== */
/* استایل‌های مُدال (Bottom Sheet) */
/* ========================================== */
.glass-sheet {
  background: rgba(248, 249, 250, 0.95) !important;
  backdrop-filter: blur(15px);
  -webkit-backdrop-filter: blur(15px);
}

.sheet-header {
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  background: rgba(255, 255, 255, 0.6);
}

.sheet-footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(12px);
  border-top: 1px solid rgba(0, 0, 0, 0.05);
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.05);
  z-index: 5;
  width: 100%;
}

.glass-box {
  background: rgba(255, 255, 255, 0.6);
  border: 1px solid rgba(255, 255, 255, 0.8);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.02);
}

.border-bottom-light:not(:last-child) {
  border-bottom: 1px dashed rgba(0, 0, 0, 0.08);
}

.color-wrapper >>> .v-avatar {
  position: relative;
  border: 3px solid rgba(0, 0, 0, 0.1) !important;
}

.gap-2 {
  gap: 8px;
}
</style>
